module.exports = __webpack_public_path__ + "static/media/cyan.fc12c6cb.svg";